import { useTransactionData } from "@/context/transactionContext";

export function useMerchantTheme() {
  const { transactionData } = useTransactionData();
  const merchantSlug = transactionData?.merchant?.slug;

  const merchantsWithoutAlreadyPaid = ["gloobet"];
  const is1xbet = merchantSlug === "1xbet";
  const isStake = merchantSlug === "stake";

  const showAlreadyPaid = !merchantsWithoutAlreadyPaid.includes(merchantSlug);

  return {
    is1xbet,
    isStake,
    showAlreadyPaid,
    merchantSlug,
  };
}
